import { inject } from '@angular/core';
import { type ResolveFn } from '@angular/router';
import { forkJoin, of, catchError } from 'rxjs';

import { OnboardingApiService } from '@shared/services/onboarding-api.service';
import { CommonDataService } from '@shared/services/common-data.service';
import { isNullOrUndefined, isEmpty } from '@utils/predicates';
import type { CountryOption } from '@shared/interfaces/opportunity.interface';

export interface PersonalDataInitData {
  countries: CountryOption[];
  choices: Record<string, unknown[]> | null;
}

export const personalDataResolver: ResolveFn<PersonalDataInitData> = () => {
  const onboardingApi = inject(OnboardingApiService);
  const commonData = inject(CommonDataService);

  const maritalChoices = commonData.get('maritalChoices');
  const hasCachedMarital = !isNullOrUndefined(maritalChoices) && !isEmpty(maritalChoices);

  const countries$ = onboardingApi.getCountries().pipe(catchError(() => of([])));
  const choices$ = hasCachedMarital
    ? of(null)
    : onboardingApi.getPersonalDataChoices().pipe(catchError(() => of(null)));

  return forkJoin({ countries: countries$, choices: choices$ });
};
